// ============================================================================
// generals.js — the Ashen Host's named officers who fight at Benjen's side.
// Mechanically they are UNIT_WARLORD units on TEAM_PLAYER with a `warlord`
// descriptor (so the WarlordRenderer draws them with a unique weapon + cape and
// the minimap/boss systems see them). Levels list which generals take the field.
// ============================================================================

import { UNIT_WARLORD, TEAM_PLAYER } from '../core/constants.js';

export const GENERAL_ROSTER = {
  'Haldric Vane':  { title: 'Warmaster of the Ashen Host', weapon: 'greatsword', hp: 2600, reach: 3.6 },
  'Sera Volk':     { title: 'the Iron Widow',              weapon: 'twin',       hp: 1500, reach: 3.2 },
  'Old Garrick':   { title: 'Hound of the Grey March',     weapon: 'maul',       hp: 1800, reach: 3.8 },
  'Lysa Fenn':     { title: 'the Ashen Arrow',             weapon: 'spear',      hp: 1300, reach: 3.6 },
  'Bram Dagor':    { title: 'the Shieldbreaker',           weapon: 'halberd',    hp: 1700, reach: 3.7 },
  'Coran Vael':    { title: 'Knight of the Silver Oath',   weapon: 'greatsword', hp: 1600, reach: 3.4 },
  'Mother Isolde': { title: 'the Grave-Warden',            weapon: 'scythe',     hp: 1500, reach: 3.9 },
};

export function spawnGeneral(world, name, x, z) {
  const def = GENERAL_ROSTER[name];
  if (!def) return null;
  const u = world.spawnUnit(TEAM_PLAYER, UNIT_WARLORD, x, z);
  if (!u) return null;
  u.hp = u.maxHp = def.hp;
  u.atkRange = def.reach;
  u.scale *= 1.05;
  u.homeX = x; u.homeZ = z;
  u.warlord = { name, title: def.title, weapon: def.weapon, guardBreakPhase: 3, ally: true };
  world.generals.push(u);
  return u;
}

export function findGeneral(world, name) {
  for (const g of world.generals) if (g.warlord && g.warlord.name === name) return g;
  return null;
}
